import { memo } from 'react';
import FullscreenDialog from '@components/Modals/components/FullscreenDialog';
import { SpinIndicator, SpinViewer } from '.';

interface Props {
  open: boolean;
  onClose: () => void;
  url: string;
  spinSetCount: number;
  ariaLabel: string;
}

const SpinDialog = ({ open, onClose, url, spinSetCount, ariaLabel }: Props) => (
  <FullscreenDialog open={open} onClose={onClose} dark>
    <div className="tw-px-6 sm:tw-px-15 [&_img]:tw-max-h-[90vh]">
      <SpinViewer url={url} count={spinSetCount} ariaLabel={ariaLabel} />
      <div className="tw-flex tw-justify-center tw-items-center">
        <SpinIndicator dark />
      </div>
    </div>
  </FullscreenDialog>
);

export default memo(SpinDialog);
